import React, { useEffect, Fragment } from 'react';
import { useSetState } from 'utils/functions.utils';
import { useSelector } from 'react-redux';
import { reducers } from 'interfaces/common.interface';
import connectSocket from 'utils/socket.utils';
import { Models } from 'utils/imports.utils';
import { setUser } from '../../utils/redux.utils';
import './mobile_screen.scss';

let socket: any;

export default function Main(props: any) {
  const [state, setState] = useSetState({
    signout: false,
    loading: false,
  });
  const user = useSelector((store: reducers) => store.user);
  let token = localStorage.getItem('token');

  useEffect(() => {
    socket = connectSocket();
    getUser();
  }, []);

  const showSuccess = (text: string) => {
    //show snack success
  };

  const getUser = async () => {
    try {
      const res: any = await Models.auth.getUser();
      setUser(res.data);
    } catch (error: any) {
      console.log('error', error);
    }
  };

  const throwError = (text: string) => {
    //show snack error
  };

  const setMainLoading = (loading: boolean) => {
    setState({ loading: loading });
  };

  if (!token) window.location.pathname = '/login';

  const renderChildren = () => {
    return React.Children.map(props.children, (child: any) => {
      if (child) {
        return React.cloneElement(child, {
          user,
          showSuccess,
          throwError,
          socket,
          setMainLoading,
        });
      }
    });
  };
  

  if (state.signout) window.location.href = '/';
  if (state.loading) return <div>Loading</div>;
  return <div className="mobile_screen">{renderChildren()}</div>;
}
